import { render, staticRenderFns } from "./StepInformation.vue?vue&type=template&id=4c144a62&"
import script from "./StepInformation.vue?vue&type=script&lang=js&"
export * from "./StepInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c144a62')) {
      api.createRecord('4c144a62', component.options)
    } else {
      api.reload('4c144a62', component.options)
    }
    module.hot.accept("./StepInformation.vue?vue&type=template&id=4c144a62&", function () {
      api.rerender('4c144a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/numerationFiles/StepInformation.vue"
export default component.exports